// extracted by css-extract-rspack-plugin
export default {"colorDefaultAlternate":"rgba(209, 209, 209, 1)","circleSize":"26px","lineSize":"2px","timelineContainer":"vertical-timeline__timelineContainer___3zL5f"};